import { render, staticRenderFns } from "./DocumentTemplateForm.vue?vue&type=template&id=3ca97772&scoped=true"
import script from "./DocumentTemplateForm.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentTemplateForm.vue?vue&type=style&index=0&id=3ca97772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca97772",
  null
  
)

export default component.exports